<template>
  <div>
    <div
      class="h-panel"
    >
      <b-button v-b-modal.help-modal>Help</b-button>
    </div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="sessions !== null && sessions.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Ext id</th>
          <th scope="col">IP</th>
          <th scope="col">Start</th>
          <th scope="col">Last request</th>
          <th scope="col">Duration</th>
        </tr>
      </thead>
      <tr
        v-for="session in sessions"
        :key="session.id"
      >
        <td class="text-right">
          {{session.id}}
        </td>
        <td>
          <span class="custom-code">{{session.extId | getOptionalStringDefaultStr('unknown')}}</span>
        </td>
        <td>
          {{session.ip | getOptionalStringDefaultStr('unknown')}}
        </td>
        <td>
          {{session.startTime | getMomentStr}}
        </td>
        <td>
          {{session.lastRequestTime | getMomentStr}}
        </td>
        <td>
          {{session.lastRequestTime - session.startTime | getDurationStr}}
        </td>
      </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показан <strong>журнал сетевых сессий</strong>.
          Сетевая сесссия — это сессия взаимодейстия клиента игры с&nbsp;сервером игры.
        </p>
        <p>
          Игрок может запустить игру без интернета.
          В этом случае сетевая сессия не начинается.
        </p>
        <p>
          В журнале сетевых сессий данные хранятся 2 недели.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'PlayerNetSessionsLog',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      sessions: null,
    };
  },

  computed: {
    message() {
      if(this.sessions !== null && this.sessions.length === 0) {
        return 'No net sessions.';
      }
      return null;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/player/${this.playerId}/net_session_log`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      const sessions = data;
      sessions.sort((a, b) => b.id - a.id);

      this.sessions = sessions;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },
};
</script>
